export default [
    {
        value: 'all_days',
        label: 'All Days'
    },
    {
        value: 'monday_to_friday',
        label: 'Monday to Friday'
    },
    {
        value: 'monday',
        label: 'Monday',
        dayOfWeek: 0,
        databaseId: 1,
    },
    {
        value: 'tuesday',
        label: 'Tuesday',
        dayOfWeek: 1,
        databaseId: 2,
    },
    {
        value: 'wednesday',
        label: 'Wednesday',
        dayOfWeek: 2,
        databaseId: 3,
    },
    {
        value: 'thursday',
        label: 'Thursday',
        dayOfWeek: 3,
        databaseId: 4,
    },
    {
        value: 'friday',
        label: 'Friday',
        dayOfWeek: 4,
        databaseId: 5,
    },
    {
        value: 'saturday',
        label: 'Saturday',
        dayOfWeek: 5,
        databaseId: 6,
    },
    {
        value: 'sunday',
        label: 'Sunday',
        dayOfWeek: 6,
        databaseId: 7,
    },
];
